<template>
    <div class="modal-body">
        <div class="d-sm-flex justify-content-between mb-3">
            <div class="p-2 mr-1">
                <b>ID: </b> {{ denuncia.id }}
            </div>

            <div class="p-2 mr-1">
                <b>Protocolo: </b> {{ denuncia.protocolo }}
            </div>

            <div class="p-2 mr-1">
                <b>Origem: </b> {{ Phone(denuncia.origem) }}
            </div>

            <div class="p-2 mr-1">
                <b>Data: </b> {{ denuncia.created_at | moment("DD/MM/YYYY") }}
            </div>

            <div class="p-2 mr-1">
                <b>Hora: </b> {{ convert_hor(denuncia.created_at) | moment("HH:mm:ss") }}
            </div>
        </div>

        <div class="d-sm-flex justify-content-center">
            <p class="vermelho">{{view_nome}} encerrada por <b>{{ ator.name }}</b> em {{ conclusao.created_at | moment("DD/MM/YYYY") }} as {{ convert_hor(conclusao.created_at) | moment("HH:mm:ss") }}</p>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label>Conclusão</label>
                    <textarea cols="30" rows="10" class="form-control" v-model="conclusao.conclusao" readonly></textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api     from '@/mixins/api.js'
	import replace from "@/mixins/replace.js"

    export default {
        name: 'conclusao',
        mixins: [ api, replace ],

        computed: {
            denuncia() {
                return this.$attrs.denuncia
            },

			view_nome(){ return this.$store.state.config_view_menu.denuncia_detalhe },
        },

        data() { return {
            ator: {},
            conclusao: {},
        }},

        async created() {
            await this.get_conclusao()
            await this.get_ator()
        },

        methods: {
            async get_ator() {
                const response = await this.GET("User", this.conclusao.usuario_id)
                if ( response.status === 'success' ) this.ator = response.result
            },

            async get_conclusao() {
                const response = await this.GET("Denuncia/Conclusao", this.denuncia.conclusao_id)
                if ( response.status === 'success' ) this.conclusao = response.result
            },

			convert_hor(payload){
				var nova_hora = new Date(payload);
				nova_hora.setHours(nova_hora.getHours()-3);
				return nova_hora;
			},
        }
    }
</script>